import axios from 'axios';

axios.interceptors.request.use(config => {
    if (typeof window === 'undefined') {
        return config;
    }

    const token = window.localStorage.getItem('token');

    if (token) {
        config.headers.Authorization = `bearer ${token}`;
    }

    return config;
});

const requestService = {
    listRequest(data) {
        return new Promise((resolve, reject) => {
            axios.post('api/solicitacoes', data)
                .then(response => {
                    resolve(response);
                })
                .catch(response => {
                    reject(response);
                });
        });
    },

    getSolicitacaoById(id) {
        return new Promise((resolve, reject) => {
            axios.get('api/solicitacao/' + id + '?random=' + Math.random())
                .then(response => {
                    resolve(response);
                })
                .catch(response => {
                    reject(response);
                });
        });
    },
    saveFiles(data) {

        return new Promise((resolve, reject) => {
            let formData = new FormData();
            if (data.arquivos != null) {
                for (var i = 0; i < data.arquivos.length; i++) {
                    formData.append("file[]", data.arquivos[i]);
                }
                data.arquivos = null;
            }

            var solicitacao = JSON.stringify(data);
            formData.append("solicitacao", solicitacao);

            axios.post('api/solicitacaoArquivo',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    save(data) {
        return new Promise((resolve, reject) => {
            axios
                .post('api/solicitacao', data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(response => {
                    reject(response.status);
                });
        });
    },
    deleteSolicitacaoById(id) {
        return new Promise((resolve, reject) => {
            axios.delete('api/deletesolicitacao/' + id)
                .then(response => {
                    resolve(response);
                })
                .catch(response => {
                    reject(response);
                });
        });
    },

    deleteCidadaoById(id) {
        return new Promise((resolve, reject) => {
            axios.delete('api/deletecidadao/' + id)
                .then(response => {
                    resolve(response);
                })
                .catch(response => {
                    reject(response);
                });
        });
    },

};

export default requestService;